import UserCouponCode from "../../../Components/CouponCode/UserCouponCode";
import React from "react";

const CouponCode = () => {
  return <UserCouponCode />;
};

export default CouponCode;
